import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGlassWater: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="glass-water, drink"><path d="M19.2539 3.75H4.75391L6.82533 20.25H17.1825L19.2539 3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M5.5 9.49999C9.83333 7.76796 14.1667 11.2321 18.5 9.49999" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconGlassWater;
